import styled from 'styled-components';
import { ReactComponent as RawMenuExpandSVG } from '../../../../assets/icons/icon_menu_expand.svg';

export const IconMenuExpand = styled(RawMenuExpandSVG)``;
